import type { LocalDto } from '@gl/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { errorMessage } from '@/lib/api';
import { queryKeys } from '@/lib/query';

/** Mutación que devuelve el LocalDto actualizado y refresca el cache. */
export function useLocalMutation<TVars>(fn: (vars: TVars) => Promise<LocalDto>, successMessage = 'Cambios guardados') {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: (local) => {
      queryClient.setQueryData(queryKeys.local(local.id), local);
      void queryClient.invalidateQueries({ queryKey: queryKeys.locals, exact: true });
      toast.success(successMessage);
    },
    onError: (err) => toast.error(errorMessage(err)),
  });
}
